<template>
    <div class="col-md-9">
        <div class="pages__title-holder mb-3">
            <h1 class="pages__title m-0">Locations</h1>
        </div>
        <div class="pages__table">
            <div class="pages__top">
                <div class="image">
                    Icon
                </div>
                <div class="slug">
                    Branch
                </div>
                <div class="route">
                    Address
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(location, index) in locations"
                    :key="location.id"
                >
                    <div class="image">
                        <img :src="getNameOfAvatar(location.logo)" alt="photo">
                    </div>
                    <div class="slug">
                        {{ location.title}}
                    </div>
                    <div class="route">
                       {{ location.address}}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a
                                :href="`/admin/panel/locations/${location.id}/edit`"
                                class="edit"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="openDeleteModal(location.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentLocationId)"
            @confirm="deleteLocation(currentLocationId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this location?</p>
                    </div>
                </div>
            </template>
        </ActionModal>
    </div>
</template>


<script>
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";

export default {
    name: 'Locations',
    components: {ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            locations: [],
            currentLocationId: null,
        }
    },
    methods: {
        async fetchLocations() {
            try {
                const { data: response } = await AdminPanelService.fetchLocations()
                this.locations = response

            } catch (e) {
                console.error(e)
            }
        },
        openDeleteModal(id) {
            this.currentLocationId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async deleteLocation(id) {
            try {
                await AdminPanelService.deleteLocation(id)
                this.locations = this.locations.filter(loc => loc.id !== id)
                this.$showSuccessMessage('The location was deleted!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The location was not deleted. Please try again')
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
    },
    mounted() {
        this.fetchLocations()
    }
}

</script>


<style scoped>

</style>
